import { render, staticRenderFns } from "./EmpiPanel.vue?vue&type=template&id=0831a3af&scoped=true"
import script from "./EmpiPanel.vue?vue&type=script&lang=js"
export * from "./EmpiPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0831a3af",
  null
  
)

export default component.exports